/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_StatueInputs */

const en_us2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of the Statue of Liberty`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} Statues of Liberty`)
	
};

const pt_br2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso da Estátua da Liberdade`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} Estátuas da Liberdade`)
	
};

const es_419_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de la Estatua de la Libertad`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} Estatuas de la Libertad`)
	
};

const pt_pt2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso da Estátua da Liberdade`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} Estátuas da Liberdade`)
	
};

const fr_fr2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids de la statue de la Liberté`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} statues de la Liberté`)
	
};

const de_de2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht der Freiheitsstatue`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Freiheitsstatuen`)
	
};

const it_it2_equivalence_statue = /** @type {(inputs: Equivalence_StatueInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso della Statua della Libertà`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} Statue della Libertà`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of the Statue of Liberty" |
* | * | "the weight of {amount} Statues of Liberty" |
*
* @param {Equivalence_StatueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_statue = /** @type {((inputs: Equivalence_StatueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_StatueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_statue(inputs)
	if (locale === "es-419") return es_419_equivalence_statue(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_statue(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_statue(inputs)
	if (locale === "de-DE") return de_de2_equivalence_statue(inputs)
	if (locale === "it-IT") return it_it2_equivalence_statue(inputs)
	return en_us2_equivalence_statue(inputs)
});
export { equivalence_statue as "equivalence.statue" }